module.exports = __webpack_public_path__ + "static/media/notes.4e287d42.png";